import { FilterPreferenceRecognizedLists } from '../../services/modules/userContextPreferences/userContextPreferences.types';
import { FilterOptionV3 } from '../Crud/filters/sharedBetweenFilters/types';
import { HandleSelectFilterProps } from './contexts/filterV3.context.types';

export interface FilterOptions<T> {
  value: T | T[];
  onChange: (value: T | T[]) => void;
}
export enum FilterStep {
  FIRST_STEP = 'FIRST_STEP',
  SECOND_STEP = 'SECOND_STEP',
}

export interface CriteriaMenu {
  filterIndex?: number;
  filterSubIndex?: number;
  step: FilterStep;
  data?: Record<string, unknown>;
  enableReturnToList?: boolean;
}

export interface DrawerProps {
  anchorEl: HTMLElement | null;
  handleClosePopover: () => void;
  classes: Record<string, string>;
  menu: CriteriaMenu;
  options: FilterOptionV3[];
  handleSelectFilter: (props: HandleSelectFilterProps) => void;
  list: FilterPreferenceRecognizedLists;
  onClickBack?: () => void;
}
